// extracted by mini-css-extract-plugin
export var dropdownButton = "_3t-0";
export var fullWidthDropdownButton = "_3t-1";
export var icon = "_3t-3";
export var iconPlaceholder = "_3t-2";
export var menuItemRow = "_3t-9";
export var separator = "_3t-e";
export var shortcutContainer = "_3t-7";
export var shortcutContainerFilled = "_3t-8";
export var shortcutIconLg = "_3t-6";
export var shortcutIconMd = "_3t-5";
export var shortcutIconSm = "_3t-4";
export var submenuChevron = "_3t-d";
export var submenuDropdown = "_3t-a";
export var submenuTriggerRow = "_3t-b";
export var submenuTriggerRowOpen = "_3t-c";